import "./LayoutNavSide.css";
import React from "react";
import NavBar from "./navbar/NavBar";
import { Outlet } from "react-router-dom";


function LayoutNavSide() {
  return (
    <div className="layout-nav-side position-relative ">
      <NavBar/>
      <div className="d-flex">
        <div className="lNS-droit">
          <Outlet />
        </div>
      </div>
    
    </div>
  );
};

export default LayoutNavSide


